

























import Vue from 'vue'
import { Icon, IconName } from '@raksul/kamii-vue'
import { ProductState } from '@/product/types'
import ModalRequestRestock from '@/product/components/ModalRequestRestock.vue'
import { requestRestock } from '@/product/services'
import { CreateUserSizeRequestInput } from '@/types/graphqlQuery'
import { SYSTEM_ERROR } from '@/common/const'

export default Vue.extend({
  components: {
    Icon,
    ModalRequestRestock
  },
  data(): {
    showRequestModal: boolean
  } {
    return {
      showRequestModal: false
    }
  },
  computed: {
    IconName() {
      return IconName
    },
    storeState(): ProductState {
      return this.$store.state
    },
    outOfStockSizes(): string[] {
      return this.$store.getters.outOfStockSizes
    }
  },
  methods: {
    toggleShowRequestModal() {
      this.showRequestModal = !this.showRequestModal
    },
    async sendRequestRestock(payload: CreateUserSizeRequestInput) {
      const data = await requestRestock({
        skuId: payload.skuId,
        email: payload.email,
        sizeIds: payload.sizeIds
      })
      if (data.success) {
        this.toggleShowRequestModal()
        alert('商品入荷のお知らせを登録しました')
      } else {
        alert(SYSTEM_ERROR.UNKNOWN)
      }
    }
  }
})
